export const convert_excel_serial_number_to_date = (excelSerialNumber) => {
  // Convert the Excel serial number to JavaScript timestamp
  var millisecondsPerDay = 24 * 60 * 60 * 1000;
  var excelEpoch = new Date(Date.UTC(1899, 11, 30)); // Excel epoch starts on December 30, 1899
  var timestamp = excelEpoch.getTime() + excelSerialNumber * millisecondsPerDay;

  // Create a JavaScript date object
  var date = new Date(timestamp);

  const date_string = date.toLocaleDateString();
  return date_string;
};

export const calculate_age = (date_str) => {
  // Split the date string into month, day, and year components
  var date_parts = date_str.split("/");

  // Convert the date components to numbers
  var day = parseInt(date_parts[0]);
  var month = parseInt(date_parts[1]) - 1; // Subtract 1 since months are zero-based (January is 0)
  var year = parseInt(date_parts[2]);

  // Create the Date object for the given date
  var given_date = new Date(year, month, day);

  // Get today's date
  var today = new Date();

  // Calculate the time difference in milliseconds
  var time_diff = today.getTime() - given_date.getTime();

  // Convert the time difference to days
  var days_diff = Math.floor(time_diff / (1000 * 60 * 60 * 24));

  return days_diff;
};

export const find_target_date = (date_str) => {
  try {
    // Split the date string into month, day, and year components
    // console.log({date_str});
    var date_parts = date_str.split("/");

    // Convert the date components to numbers
    var day = parseInt(date_parts[0]);
    var month = parseInt(date_parts[1]) - 1; // Subtract 1 since months are zero-based (January is 0)
    var year = parseInt(date_parts[2]);

    // Create the Date object for the given date
    var given_date = new Date(year, month, day);
    // Calculate the time difference in milliseconds
    var time_diff = 1000 * 60 * 60 * 24 * 30;

    // Calculate new timestamp
    var new_date = new Date(given_date.getTime() + time_diff);
    const date_string = new_date.toLocaleDateString();
    return date_string;
  } catch (error) {
    console.log(error);
  }
};